module.exports = __webpack_public_path__ + "opensource-forum-fe/static/img/app_logo_new.3ed4ce00.png";